import {FormField, FormFieldType, SelectionOption} from 'lionheartland';

export class PostProductFormFields {

    public name: FormField
    public sku: FormField
    public exRef: FormField
    public active: FormField

    constructor() {

        this.name = new FormField(
          'name',
          'Name',
          null,
          FormFieldType.text,
          true,
        )
        this.sku = new FormField(
          'sku',
          'Sku',
          null,
          FormFieldType.text,
          true,
          true,
          ''
        )
        this.exRef = new FormField(
          'exRef',
          'Ex ref',
          null,
          FormFieldType.text,
          false,
        )
        this.active = new FormField(
          'active',
          'Active',
          null,
          FormFieldType.boolean,
          true,
          true,
          true
        )

    }
}

const fields = new PostProductFormFields()

export const postProductFormFieldOptions: {[key: string]: FormField} = {
  name: fields.name,
  sku: fields.sku,
  exRef: fields.exRef,
  active: fields.active,
};